/**
 * Path-prefix detection for CloudFront multi-vertical hosting (NER-4111).
 *
 * The same build is served under distinct prefixes — `/citame/admin` (Citame,
 * NER-1479) and `/consultame/admin` (Consultame, NER-4044/NER-4046). Both the
 * React Router basename and any full-page redirect (e.g. the 401 handler in
 * services/api.js) MUST resolve to the currently active prefix. A hard redirect
 * to a bare `/login` would drop the user onto an unmapped root path (no
 * CloudFront behavior → 404) and lose the vertical chrome, which was the login
 * gap left open by NER-4044 Phase 1.
 *
 * Match the most specific prefix first; otherwise empty string (root hosting or
 * local dev).
 */
export const PATH_BASENAMES = ['/consultame/admin', '/citame/admin'];

export function getBasename(pathname = window.location.pathname) {
  return PATH_BASENAMES.find((prefix) => pathname.startsWith(prefix)) || '';
}
